<template>
    <div class="billOperationRecord public_Spacing">
        <div class="pulbic_oparetionBlock">
            <div class="public_operatArea">
                <span class="pulic_operatArea_now pulic_cursor" :class="dateNowDayActive ? 'public_dateActive' : ''"
                    @click="getNowDay">当日</span>
                <span class="public_operatArea_yesterday pulic_cursor"
                    :class="dateYesterdayActive ? 'public_dateActive' : ''" @click="getYesterday">昨天</span>
                <span class="pulic_operatArea_now pulic_cursor" :class="dateNowMonthActive ? 'public_dateActive' : ''"
                    @click="sameMonth">当月</span>
                <span class="public_operatArea_yesterday pulic_cursor"
                    :class="dateLastMonthActive ? 'public_dateActive' : ''" @click="lastMonth">上月</span>
                <div class="public_operatArea_timePicker pulic_cursor">
                    <el-date-picker v-model="date" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
                        :picker-options="startDateDisabled" @change="datePickerChange" start-placeholder="开始日"
                        end-placeholder="结束日" class="pulic_cursor">
                    </el-date-picker>
                </div>
                <div class="public_oparetionBlock_Menu">
                    <label class="public_lbSty">厂家：</label>
                    <!-- <el-select class="public_optionSty dropDown_Define" v-model="enterpriseTwo" filterable clearable placeholder="请选择">
                        <el-option v-for="item in enterpriseTwoOptionList" :key="item.SETTB99ID"
                            :label="item.SETTB99CA00" :value="item.SETTB99ID">
                        </el-option>
                    </el-select> -->
                    <EnhancedSelect v-model="enterpriseTwo" :options="enterpriseTwoOptionList" label-key="SETTB99CA00"
                        value-key="SETTB99ID" pinyin-key="SETTB99CA00PY" :enable-pinyin-search="true"
                        :enable-first-letter-search="true" />
                </div>
                <div class="public_operatBtn">
                    <el-button type="primary" @click="queryClick">查询</el-button>
                </div>
            </div>
        </div>
        <!-- 总额 -->
        <div class="staticTotalAmount">
            <div class="content_box">
                总盈亏:{{ sum.sumProfit }}
            </div>
            <div class="content_box">
                总毛利:{{ sum.sumMargin }}
            </div>
            <div class="content_box">
                预估总服务费:{{ sum.sumSETTB425CA06 }}
            </div>
            <div class="content_box">
                实收总服务费:{{ sum.sumShiShou }}
            </div>
            <div class="content_box">
                总运费:{{ sum.sumFreight }}
            </div>
        </div>
        <div class="billOperationRecord-table pulbic_table_container">
            <el-table tooltip-effect="dark" :data="tableData" style="width: 100%;" max-height="90%"
                :default-sort="{ prop: 'waterNum', order: 'descending' }" :header-cell-style="{
                    color: 'rgba(51,51,51,1)',
                    'font-weight': 'bold',
                }" class="public_tableColumn">
                <el-table-column prop="SETTB425CA17" label="厂家"></el-table-column>
                <el-table-column prop="SETTB425CA04" label="销售总额"></el-table-column>
                <el-table-column prop="SETTB425CA05" label="购进总额"> </el-table-column>
                <el-table-column prop="margin" label="毛利"></el-table-column>
                <el-table-column prop="SETTB425CA06" label="预估服务费"></el-table-column>
                <el-table-column prop="charge" label="实收服务费"></el-table-column>
                <el-table-column prop="SETTB425CA04Two" label="总运费"></el-table-column>
                <el-table-column prop="SETTB425CA05Two" label="运费成本"></el-table-column>
                <el-table-column prop="SETTB425CA06Two" label="预估运费服务费"></el-table-column>
                <el-table-column prop="charge2" label="实收运费服务费"> </el-table-column>
                <el-table-column prop="profit" label="盈亏">
                    <template slot-scope="scope">
                        <div :class="scope.row.profit > 0 ? 'grennColor' : 'redColor'">{{ scope.row.profit }}</div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pulbic_pagesize">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
                    layout="total,sizes, prev, pager, next" :total="pagingPageMo">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import EnhancedSelect from '../../components/EnhancedSelect.vue';
export default {
    components: {
        EnhancedSelect
    },
    name: 'CustomerPhase',
    data() {
        return {
            date: [], //日期
            dateNowDayActive: false,
            dateYesterdayActive: false,
            dateNowMonthActive: false,
            dateLastMonthActive: false,
            tableData: [],
            enterpriseTwoOptionList: [],
            enterpriseTwo: '',
            pageMo: 1, //默认列表页码
            limitMo: 10, //每页的条数
            pagingPageMo: 0, //分页--数据列表共有的条数
            currentPage: 1, //设置当前页默认为1
            // 时间限制
            // 限制开始日期不能超过当前日期
            startDateDisabled: {
                disabledDate(time) {
                    return time.getTime() > Date.now()
                },
            },
            sum: {
                sumDiscount: 0,
                sumFreight: 5,
                sumMargin: 0,
                sumProfit: 0,
                sumSETTB425CA06: 0
            }
        }
    },
    created() {
        this.optionLists()
        this.getNowDay()
    },
    mounted() {
        this.pageList()
    },
    methods: {
        optionLists() {
            var List = [
                {
                    SETTB99ID: '',
                    SETTB99CA00: '全部',
                },
            ]
            var url = '/ormtb807/querySettb99'
            this.axios
                .post(url)
                .then(res => {
                    if (res.data.code == 200) {
                        var data = res.data.data
                        // 二级企业
                        this.enterpriseTwoOptionList = [...List, ...data]
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        // 查询
        queryClick() {
            this.pageList()
        },
        // 列表
        pageList() {
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            const postData = {
                type: 2,
                SETTB99ID: this.enterpriseTwo,
                page: this.pageMo,
                limit: this.limitMo,
                startTime: `${this.date[0]} 00:00:00`,
                endTime: `${this.date[1]} 23:59:59`,
            }

            this.tableData = []
            const url = '/ormtb807/queryList'
            this.axios
                .post(url, postData)
                .then(res => {
                    if (res.data.code == 200) {
                        var data = res.data.data.data
                        this.tableData = data
                        this.pagingPageMo = res.data.count
                        this.sum = res.data.data.sum
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                    loading.close()
                })
                .catch(() => {
                    loading.close()
                })
        },
        //获取当前时间
        getNowDay() {
            var date = new Date().getTime()
            var nowDay = this.$baseAPI.dateFtt('yyyy-MM-dd', new Date(date))
            this.date = [nowDay, nowDay]
            this.dateNowDayActive = true
            this.dateYesterdayActive = false
            this.dateNowMonthActive = false
            this.dateLastMonthActive = false
        },
        //获取昨天时间
        getYesterday() {
            var hms = new Date().getTime() - 86400000
            var nowDay = this.$baseAPI.dateFtt('yyyy-MM-dd', new Date(hms))
            this.date = [nowDay, nowDay]
            this.dateNowDayActive = false
            this.dateYesterdayActive = true
            this.dateNowMonthActive = false
            this.dateLastMonthActive = false
        },
        //获取当月时间
        sameMonth() {
            var date = new Date()
            var hms = date.setDate(1)
            var firstDay = this.$baseAPI.dateFtt('yyyy-MM-dd', new Date(hms))
            var nextdate = new Date().getTime()
            var nextDay = this.$baseAPI.dateFtt('yyyy-MM-dd', new Date(nextdate))
            this.date = [firstDay, nextDay]
            this.startTime = this.date[0]
            this.endTime = this.date[1]
            this.dateNowDayActive = false
            this.dateYesterdayActive = false
            this.dateNowMonthActive = true
            this.dateLastMonthActive = false
        },
        //获取上月时间
        lastMonth() {
            var nowdays = new Date()
            var year = nowdays.getFullYear()
            var month = nowdays.getMonth()
            if (month == 0) {
                month = 12
                year = year - 1
            }
            if (month < 10) {
                month = '0' + month
            }
            var firstDayOfPreMonth = year + '-' + month + '-' + '01'
            var lastDay = new Date(year, month, 0)
            let lastDayOfPreMonth = year + '-' + month + '-' + lastDay.getDate()
            this.date = [firstDayOfPreMonth, lastDayOfPreMonth]
            this.dateNowDayActive = false
            this.dateYesterdayActive = false
            this.dateNowMonthActive = false
            this.dateLastMonthActive = true
        },
        handleSizeChange(val) {
            this.pageMo = 1
            this.limitMo = val
            this.pageList()
        },
        // 点击页码
        handleCurrentChange(val) {
            this.pageMo = val
            this.pageList()
        },
        datePickerChange(e) {
            // 先重置所有状态
            this.dateNowDayActive = false
            this.dateYesterdayActive = false
            this.dateNowMonthActive = false
            this.dateLastMonthActive = false

            if (e && e.length === 2) {
                const [startDate, endDate] = e
                const start = new Date(startDate)
                const end = new Date(endDate)

                // 判断是否为当日
                const today = new Date()
                const todayStr = this.formatDate(today)
                if (startDate === todayStr && endDate === todayStr) {
                    this.dateNowDayActive = true
                    return
                }

                // 判断是否为昨日
                const yesterday = new Date(today)
                yesterday.setDate(yesterday.getDate() - 1)
                const yesterdayStr = this.formatDate(yesterday)
                if (startDate === yesterdayStr && endDate === yesterdayStr) {
                    this.dateYesterdayActive = true
                    return
                }

                // 判断是否为当月
                const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1)
                const currentMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0)
                const currentMonthStartStr = this.formatDate(currentMonthStart)
                const currentMonthEndStr = this.formatDate(currentMonthEnd)
                if (startDate === currentMonthStartStr && endDate === currentMonthEndStr) {
                    this.dateNowMonthActive = true
                    return
                }

                // 判断是否为上月
                const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1)
                const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0) // 当月第0天就是上个月最后一天
                const lastMonthStartStr = this.formatDate(lastMonthStart)
                const lastMonthEndStr = this.formatDate(lastMonthEnd)
                if (startDate === lastMonthStartStr && endDate === lastMonthEndStr) {
                    this.dateLastMonthActive = true
                    return
                }
            }
        },

        // 添加一个格式化日期的方法，确保格式一致
        formatDate(date) {
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        }
    },
}
</script>

<style scoped>
.CustomerfillingDig-tab {
    padding-left: 20px;
}

.public_criteriaRange /deep/ .el-input__inner {
    height: 1.7vw;
}

.CustomerfillingDig-tab-li,
.rechargeType-tab-li {
    display: flex;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 16px;
    color: #333;
    vertical-align: top;
}

.CustomerfillingDig-tab-li>div {
    border: 1px solid #cdcdcd;
    border-top: none;
}

.CustomerfillingDig-tab-li>div:first-child {
    border-right: none;
}

.CustomerfillingDig-tab-li:first-child>div {
    border-top: 1px solid #cdcdcd;
}

.CustomerfillingDig-tab-li>div:last-child,
.rechargeType-tab-li>div:last-child {
    border: none;
    color: #ff4d35;
}

.CustomerfillingDig-tab-li-text {
    flex: 0.8;
    background: rgba(240, 252, 255, 1);
}

.CustomerfillingDig-tab-li-ipt {
    flex: 0.8;
}

.rechargeType-tab-li-text {
    flex: 0.35;
}

.rechargeType-tab-li-ipt {
    flex: 0.7;
}

.CustomerfillingDig-tab-li-ipt input,
.rechargeType-tab-li-ipt input {
    height: 46px;
    width: 100%;

    text-align: center;

    box-sizing: border-box;
    font-size: 16px;
    color: #333;
}

.CustomerfillingDig-tab-li-ipt input {
    outline: none;
    border: none;
    vertical-align: top;
}

.rechargeType-tab-li-ipt input {
    /* border-radius: 8px; */
    /* outline: none; */
}

.CustomerfillingDig-tab-li-b,
.rechargeType-tab-li-b {
    flex: 0.3;
}

.CustomerfillingDig-tab-btn {
    text-align: center;
    margin-top: 30px;
}

.DWD-li {
    display: flex;
    height: 35px;
    line-height: 35px;
    box-sizing: border-box;
    border: 1px solid #999;
    font-size: 16px;
    color: #333;
}

.DWD-li>div {
    padding: 0 5px;
    height: 34px;
    overflow: hidden;
    box-sizing: border-box;
}

.DWD-li-title {
    width: 150px;
    text-align: center;
    border-right: 1px solid #999;
    background-color: rgba(0, 163, 255, 0.1);
}

.right_btn {
    float: right;
    margin-bottom: 10px;
}

.DWD-li-text {
    flex: 1;
}

.DWD-li-text input {
    width: 100%;
    height: 35px;
    line-height: 35px;
    border: none;
    outline: none;
}

.DWD-li+.DWD-li {
    border-top: none;
}

.DWD-table {
    display: flex;
}

.DWD-table-left-flex {
    flex: 1;
}

.DWD-table>div>div {
    padding: 0 5px;
    height: 35px;
    line-height: 35px;
    overflow: hidden;
    text-align: center;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    box-sizing: border-box;
}

.DWD-table>div>div:first-child {
    background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table-left-title>div {
    width: 101px;
    text-align: center;
    background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table .DWD-table-left-title>div {
    padding: 0 5px;
    height: 35px;
    line-height: 35px;
    overflow: hidden;
    box-sizing: border-box;
    border-left: 1px solid #999;
    border-bottom: 1px solid #999;
}

.DetailsWater-img {
    margin-top: 30px;
}

.DetailsWater-img-text {
    display: inline-block;
    width: 101px;
    text-align: center;
    vertical-align: top;
}

.car-number-add {
    /* text-transform: uppercase; */
}

.billOperationRecord-table {
    padding: 30px 0;
    box-sizing: border-box;
}

.public_singleMenu .pulic_carNumber {
    margin-top: 6px;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    font-size: 14px;
    display: inline-block;
}

.pulic_operatArea_now:hover,
.public_operatArea_yesterday:hover {
    background-color: #ccc;
}

.billOperationRecord .systemCodePC-add-code-table-li-ipt {
    flex: 1.5;
}

.fontBlue {
    color: rgba(25, 159, 255, 1) !important;
}

.public_oparetionBlock_Menu .pulic_carNumber {
    margin-top: 6px;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    font-size: 14px;
    display: inline-block;
}

.billOperationRecord .public_oparetionBlock_Menu {
    height: 45px;
    align-items: center;
    margin-left: 20px;
}

.billOperationRecord {
    background-color: #f3f3f3;
}

.billOperationRecord th,
.billOperationRecord td {
    text-align: center !important;
}

.pulbic_oparetionBlock {
    padding: 0 !important;
    margin-bottom: 0 !important;
}

.public_lbSty {
    width: auto !important;
}

.staticTotalAmount {
    display: flex;
    justify-content: space-between;
    background-color: #fff;
}

.content_box {
    width: 16%;
    padding: 25px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    text-align: center;
    color: rgb(235, 170, 122);
    font-size: 16px;
}

.grennColor {
    color: green;
}

.redColor {
    color: red;
}
</style>
